<template>
  <el-container class="background-white">
    <el-header>
      <h1>Order Fulfillment with D365</h1>
    </el-header>
    <el-main>
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :xs="24" :sm="20" :md="16" :lg="12">
          <el-card shadow="hover">
            <h4>Upload a CSV File that only contain a list of order IDs that need to be fulfilled</h4>
            <el-upload
                action=""
                :multiple="false"
                :limit="1"
                :on-change="handleUploadChange"
                :auto-upload="false"
                accept=".csv"
                :file-list="fileList"
                drag
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drag your CSV file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                Only CSV files are accepted
              </div>
            </el-upload>
            <div class="button-group">
              <el-button
                  :loading="loading"
                  :disabled="!fileList.length"
                  type="primary"
                  @click="uploadFile"
              >
                Submit
              </el-button>
              <el-button @click="resetForm">Cancel</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import axios, {RepositoryError} from '../../../repositories';

export default {
  name: 'Fulfillment',
  data() {
    return {
      fileList: [],
      loading: false,
    };
  },
  methods: {
    handleUploadChange(file, fileList) {
      this.fileList = fileList;
    },
    resetForm() {
      this.fileList = [];
    },
    async uploadFile() {
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('file', this.fileList[0].raw);
        await axios.post('/orders/fulfillment', formData, {
          headers: {'Content-Type': 'multipart/form-data'},
        });
        this.$message.success("Successfully uploaded, fulfilling in progress. You will receive an email report once it's done");
        this.resetForm();
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$message.error(`Upload failed: ${error.response.data.message}`);
        } else {
          this.$message.error('Upload failed. Please try again later.');
        }
      } finally {
        this.loading = false;
      }
    },
  },
};

</script>

<style scoped>
.button-group {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.button-group .el-button {
  margin-left: 10px;
}

.el-upload {
  margin-top: 20px;
}

h4 {
  margin-bottom: 20px;
}
</style>